(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('.reviews-carousel__track');
    var prevBtn = root.querySelector('.reviews-carousel__arrow--prev');
    var nextBtn = root.querySelector('.reviews-carousel__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideAmount() {
      var slide = track.querySelector('.reviews-carousel__slide');
      if (!slide) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByAmount(direction) {
      track.scrollBy({
        left: direction * slideAmount(),
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    }

    prevBtn.addEventListener('click', function () {
      scrollByAmount(-1);
    });
    nextBtn.addEventListener('click', function () {
      scrollByAmount(1);
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    var autoplay = root.dataset.autoplay === 'true' && !reducedMotion;
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
    var timer = null;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (autoplay) {
      startAutoplay();
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      // don't auto-rotate while the user is actively dragging/swiping the track
      track.addEventListener('pointerdown', stopAutoplay);
      window.addEventListener('pointerup', startAutoplay);
      window.addEventListener('pointercancel', startAutoplay);
    }
  }

  function initAll() {
    document.querySelectorAll('.reviews-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.reviews-carousel');
    if (root) initCarousel(root);
  });
})();
